import * as React from 'react';
import * as types from 'modules/types/smSupplierManagement';
import PropTypes from 'prop-types';
import contactsMessages from 'messages/Models/SupplierContact';
import titleMessages from 'messages/CompanyManagement/CardTitle';
import classnames from 'classnames';
import _ from 'lodash';
import { Row, Col, Form, Card } from '@beehive/components';
import { SUPPLIER_CONTRACTS_KEYS, CONTRACTS_TYPES } from '../utils';
import { getCurValue } from './ServiceInfo';

const messages = { ...contactsMessages, ...titleMessages };

const CONTACT_SHOW_KEYS = ['job_title', 'email', 'telephone'];

const Contact: React.SFC<types.SupplierMangementDetail> = (props, context) => {
  const { intl } = context;
  const { supplier_contacts = [], loading } = props;
  return (
    <Card
      titleNode={intl.formatMessage(messages.supplierContacts)}
      className="contact-info-show"
      loading={loading}
    >
      <Row gutter={24} type="flex">
        {
          CONTRACTS_TYPES.map((item: string, idx: number) => {
            const contract = supplier_contacts.find((i: any) => i.contact_type === item);
            const dirtyAttrs: any[] = _.get(props, `dirty_attrs.${item}`, []);
            const nameClassName = classnames('supplier_contact_details_name', {
              ['color-red']: dirtyAttrs.includes('name'),
            });
            return (
              <Col span={12} key={item}>
                <div className="supplier_contact_type">
                  {intl.formatMessage(messages[SUPPLIER_CONTRACTS_KEYS.name.label[idx]])}
                </div>
                <div className="supplier_contact_details">
                  <div className={nameClassName}>
                    {getCurValue(contract && contract.name || '')}
                  </div>
                  <Form isLabelVertical>
                    {
                      CONTACT_SHOW_KEYS.map((key: string) => {
                        const item = SUPPLIER_CONTRACTS_KEYS[key];
                        const label = typeof item.label === 'string' ? item.label : item.label[idx];
                        return (
                          <Form.Item
                            label={label && intl.formatMessage(messages[label])}
                            key={key}
                            itemColProps={{ span: 24 }}
                            className={classnames(key, { ['color-red']: dirtyAttrs.includes(key) })}
                          >
                            <span>
                              {getCurValue(contract && contract[key])}
                            </span>
                          </Form.Item>
                        );
                      })
                    }
                  </Form>
                </div>
              </Col>
            );
          })
        }
      </Row>
    </Card>
  );
};

Contact.contextTypes = {
  intl: PropTypes.object,
};

export default Contact;
